import { render, staticRenderFns } from "./AreasExpertise.vue?vue&type=template&id=44c92a60&"
import script from "./AreasExpertise.vue?vue&type=script&lang=js&"
export * from "./AreasExpertise.vue?vue&type=script&lang=js&"
import style0 from "./AreasExpertise.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports